module.exports = __webpack_public_path__ + "static/media/clients_blue.1c28f555.png";